import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  ConfirmDialog,
  CustomCheckbox,
  CustomInputTextArea,
  CustomModal,
  CustomPanel,
  InputNumeroInteiro,
  PageHeader,
  InputText,
  CustomDropdown,
  Btn,
  CustomDataTableHeader,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  deleteModeloImportacao,
  downloadModeloImportacao,
  getTiposDeArquivosDeImportacao,
  saveTipoDeArquivoDeImportacao,
  uploadModeloImportacao,
} from '../../../../services/api/https/system/system.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import { vermelho } from '../../../../assets/js/colors'
import { downloadFile } from '../../../../services/util/download.service'

const sortTiposByCodigo = tipos =>
  [...tipos].sort((a, b) => Number(a.id || 0) - Number(b.id || 0))

function TipoArquivoImportacao({ history, dispatch }) {
  // Vars
  const initTipo = { id: null, name: '', ativo: 1, tipo: '', path_modelo: null, description: '' }
  // Hooks
  const [showModal, setShowModal] = useState(false)
  const [tipos, setTipos] = useState([])
  const [selectedTipo, setSelectedTipo] = useState(initTipo)
  useEffect(() => {
    getTiposDeArquivo()
  }, [])
  const [globalFilter, setGlobalFilter] = useState('')

  // Events
  const onItemClicked = tipo => {
    setSelectedTipo(tipo)
    setShowModal(true)
  }

  const updateTipoList = tipo => {
    setTipos(prevTipos => {
      const index = prevTipos.findIndex(t => t.id === tipo.id)
      if (index === -1) return sortTiposByCodigo([...prevTipos, tipo])

      const nTipos = [...prevTipos]
      nTipos[index] = tipo
      return sortTiposByCodigo(nTipos)
    })
  }

  const onModalSuccess = tipo => {
    updateTipoList(tipo)
    setShowModal(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, error))
    setShowModal(false)
  }

  const onBtnNovoClick = () => {
    setSelectedTipo(initTipo)
    setShowModal(true)
  }

  // Helpers
  const getTiposDeArquivo = async () => {
    try {
      const fetchedTipos = await getTiposDeArquivosDeImportacao()
      setTipos(sortTiposByCodigo(fetchedTipos))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <React.Fragment>
      <PageHeader>S.12 - Tipos de Arquivos de Importação</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onVoltar={history.goBack}
          btnLabel="Novo"
          showBtnNovo={true}
          onNovo={onBtnNovoClick}
        >
          <DataTable
            value={tipos}
            emptyMessage="Não existe Tipo de Arquivo de Importação Cadastrado"
            selectionMode="single"
            onSelectionChange={e => onItemClicked(e.value)}
            rows={10}
            paginator
            globalFilter={globalFilter}
            header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
          >
            <Column field="id" header="Código" style={tableCellCentered(80)} />
            <Column field="name" header="Modelo de Importação" />
            <Column field="tipo" header="Tipo" style={tableCellCentered(100)} />
            <Column
              field="ativo"
              header="Ativo"
              style={tableCellCentered(80)}
              body={tipo => <CustomCheckbox disabled={true} checked={tipo.ativo === 1} />}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <TipoModal
        isVisible={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={onModalSuccess}
        onError={onModalError}
        onUpdate={updateTipoList}
        dispatch={dispatch}
        tipo={selectedTipo}
      />
    </React.Fragment>
  )
}

function TipoModal({ tipo, isVisible, onClose, onSuccess, onError, onUpdate, dispatch }) {
  // Vars
  const modelos = [
    { label: 'EDI', value: 'edi' },
    { label: 'Excel', value: 'excel' },
    { label: 'Xml', value: 'xml' },
    { label: 'PDF', value: 'pdf' },
    { label: 'RTF', value: 'rtf' },
  ]
  // Hooks
  const [selectedTipo, setSelectedTipo] = useState(tipo)
  const [showConfirmDeleteModelo, setShowConfirmDeleteModelo] = useState(false)
  const [isDeletingModelo, setIsDeletingModelo] = useState(false)
  useEffect(() => {
    setSelectedTipo({
      ...tipo,
      path_modelo: tipo.path_modelo || null,
      description: tipo.description || '',
    })
  }, [tipo])

  // Events
  const onBtnSalvarClick = async () => {
    try {
      const fetchedTipo = await saveTipoDeArquivoDeImportacao({
        ...selectedTipo,
        path_modelo: selectedTipo.path_modelo || null,
        description: selectedTipo.description || null,
      })
      onSuccess(fetchedTipo)
    } catch (e) {
      onError(errorHandler(e))
    }
  }

  const getModeloFilename = () => {
    const modeloPath = selectedTipo.path_modelo ? selectedTipo.path_modelo.split('?')[0] : ''
    const parts = modeloPath.split('/')
    return parts[parts.length - 1]
  }

  const hasModelo = !!(selectedTipo.path_modelo && selectedTipo.path_modelo.trim())

  const showError = message => {
    dispatch(showMessageBox(null, message))
  }

  const validateTipoForModelo = () => {
    if (!selectedTipo.id || !Number.isInteger(Number(selectedTipo.id))) {
      showError('O campo ID deve ser informado para enviar o Modelo')
      return false
    }
    if (!selectedTipo.name || !selectedTipo.name.trim()) {
      showError('O campo Modelo de Arquivo e Importação deve ser informado')
      return false
    }
    if (!selectedTipo.tipo) {
      showError('O campo Tipos de Arquivos deve ser informado')
      return false
    }
    return true
  }

  const onBtnUploadModeloClick = () => {
    if (!validateTipoForModelo()) return

    const input = document.createElement('input')
    input.type = 'file'
    input.onchange = async e => {
      const file = e.target.files[0]
      if (!file) return

      try {
        dispatch(showLoadingBox('Salvando tipo de importação...'))
        const tipoPersistido = await saveTipoDeArquivoDeImportacao({
          ...selectedTipo,
          path_modelo: selectedTipo.path_modelo || null,
          description: selectedTipo.description || null,
        })

        dispatch(showLoadingBox('Fazendo upload do modelo...'))
        const uploadResult = await uploadModeloImportacao(
          tipoPersistido.id,
          tipoPersistido.name,
          file,
        )
        const tipoAtualizado = await saveTipoDeArquivoDeImportacao({
          ...tipoPersistido,
          path_modelo: uploadResult.url,
          description: tipoPersistido.description || null,
        })

        setSelectedTipo({
          ...tipoAtualizado,
          description: tipoAtualizado.description || '',
        })
        onUpdate(tipoAtualizado)
        dispatch(showMessageBox('Modelo enviado com sucesso!', null))
      } catch (e) {
        dispatch(showMessageBox(null, errorHandler(e)))
      } finally {
        dispatch(hideLoadingBox())
      }
    }
    input.click()
  }

  const onBtnBaixarModeloClick = async () => {
    const filename = getModeloFilename()
    if (!filename) {
      showError('Modelo não encontrado para download')
      return
    }

    try {
      dispatch(showLoadingBox('Baixando modelo...'))
      const blob = await downloadModeloImportacao(filename)
      downloadFile(blob, filename)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onConfirmExcluirModelo = async () => {
    const filename = getModeloFilename()
    if (!filename) {
      showError('Modelo não encontrado para exclusão')
      setShowConfirmDeleteModelo(false)
      return
    }

    try {
      setIsDeletingModelo(true)
      dispatch(showLoadingBox('Excluindo modelo...'))
      await deleteModeloImportacao(filename)
      const tipoAtualizado = await saveTipoDeArquivoDeImportacao({
        ...selectedTipo,
        path_modelo: null,
        description: selectedTipo.description || null,
      })

      setSelectedTipo({
        ...tipoAtualizado,
        path_modelo: null,
        description: tipoAtualizado.description || '',
      })
      onUpdate(tipoAtualizado)
      dispatch(showMessageBox('Modelo excluído com sucesso!', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsDeletingModelo(false)
      setShowConfirmDeleteModelo(false)
      dispatch(hideLoadingBox())
    }
  }

  // Render
  return (
    <CustomModal
      onClose={onClose}
      isVisible={isVisible}
      header={selectedTipo && selectedTipo.id ? 'Editando Tipo' : 'Novo Tipo'}
    >
      <div className="p-grid">
        <div className="p-col-2">
          <InputNumeroInteiro
            label="Código"
            value={selectedTipo.id === 0 ? '' : selectedTipo.id}
            onChange={value => setSelectedTipo({ ...selectedTipo, id: Number(value) })}
            marginTop={0}
          />
        </div>
        <div className="p-col-12">
          <InputText
            marginTop={0}
            onChange={value => setSelectedTipo({ ...selectedTipo, name: value })}
            value={selectedTipo.name}
            label="Modelo de Arquivo e Importação"
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            value={selectedTipo.tipo}
            marginTop={0}
            onChange={value => setSelectedTipo({ ...selectedTipo, tipo: value })}
            options={modelos}
            label="Tipos de Arquivos"
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 35 }}>
          <CustomCheckbox
            onChange={value => setSelectedTipo({ ...selectedTipo, ativo: value ? 1 : 0 })}
            checked={selectedTipo.ativo === 1}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <div style={{ marginTop: 0 }}>
            <div style={{ fontSize: '0.8rem', marginBottom: 8, color: '#14B0BF' }}>Modelo</div>
            {hasModelo ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                <Btn onClick={onBtnBaixarModeloClick}>Baixar Modelo</Btn>
                <Btn backgroundColor={vermelho} onClick={() => setShowConfirmDeleteModelo(true)}>
                  Excluir Modelo
                </Btn>
              </div>
            ) : (
              <Btn onClick={onBtnUploadModeloClick}>Upload Modelo</Btn>
            )}
          </div>
        </div>
        <div className="p-col-12">
          <CustomInputTextArea
            marginTop={0}
            rows={4}
            onChange={value => setSelectedTipo({ ...selectedTipo, description: value })}
            value={selectedTipo.description || ''}
            label="Descrição"
          />
        </div>
        <div className="p-col-6">
          <Btn onClick={onBtnSalvarClick}>Salvar</Btn>
        </div>
      </div>
      <ConfirmDialog
        title="Confirmação"
        isVisible={showConfirmDeleteModelo}
        content="Tem certeza que deseja excluir o Modelo desse Tipo de importação? Essa ação não poderá ser desfeita"
        onOk={onConfirmExcluirModelo}
        onCancelar={() => setShowConfirmDeleteModelo(false)}
        disabled={isDeletingModelo}
        okLabel="Confirmar"
        cancelLabel="Cancelar"
      />
    </CustomModal>
  )
}

export default connect()(withRouter(TipoArquivoImportacao))
